import { render } from "./BaseModalV3.vue?vue&type=template&id=78642862&scoped=true"
import script from "./BaseModalV3.vue?vue&type=script&lang=js"
export * from "./BaseModalV3.vue?vue&type=script&lang=js"

import "./BaseModalV3.vue?vue&type=style&index=0&id=78642862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78642862"]])

export default __exports__